import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-4 items-center" }
const _hoisted_2 = { class: "font-bold text-2xl" }
const _hoisted_3 = { class: "font-bold text-gray-500 text-xs leading-none" }
const _hoisted_4 = { class: "bg-pink-50 border-2 border-b-4 border-black rounded-e-md absolute -left-0.5 top-20 pl-2 pr-2" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "text-pink-800 font-semibold text-center mt-1" }
const _hoisted_7 = { class: "bg-pink-800 border-2 border-b-4 border-black rounded-s-md absolute -right-0.5 top-20 pl-2 pr-2" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-pink-200 font-semibold text-center mt-1" }
const _hoisted_10 = { class: "absolute right-2 bottom-3 pl-2 pr-2" }
const _hoisted_11 = { class: "text-pink-800/50 text-xs font-bold" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_team_player = _resolveComponent("team-player")

  return (_openBlock(), _createElementBlock("article", {
    onMousemove: _cache[1] || (_cache[1] = (...args) => ($options.mouseMove && $options.mouseMove(...args))),
    onClick: _cache[2] || (_cache[2] = (...args) => ($options.dropPlayer && $options.dropPlayer(...args))),
    class: "px-2 py-2 relative bg-white border-2 border-b-4 rounded-lg border-black aspect-[9/12] flex flex-col"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: "/img/escudo-universitario.png",
          alt: "",
          class: "h-10 w-10"
        })
      ], -1 /* HOISTED */)),
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString($data.name), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, _toDisplayString($data.byline), 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" Votes "),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString($data.votes), 1 /* TEXT */),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-gray-500 text-xs mb-1 hover:text-pink-800" }, [
          _createCommentVNode(" Heart icon "),
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "size-8"
          }, [
            _createElementVNode("path", { d: "m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" })
          ])
        ], -1 /* HOISTED */))
      ])
    ]),
    _createCommentVNode(" Shuffles "),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString($data.shuffles), 1 /* TEXT */),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-pink-100 text-xs mb-1 hover:text-white" }, [
          _createCommentVNode(" Arrow path rounded square icon "),
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "size-8 mx-auto"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 0 1 3.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 0 0-4.392-4.392 49.422 49.422 0 0 0-7.436 0A4.756 4.756 0 0 0 3.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 1 0 1.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 0 1 3.01-3.01c1.19-.09 2.392-.135 3.605-.135Zm-6.97 6.22a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 0 0 4.392 4.392 49.413 49.413 0 0 0 7.436 0 4.756 4.756 0 0 0 4.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 0 0-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 0 1-3.01 3.01 47.953 47.953 0 0 1-7.21 0 3.256 3.256 0 0 1-3.01-3.01 47.759 47.759 0 0 1-.1-1.759L6.97 15.53a.75.75 0 0 0 1.06-1.06l-3-3Z",
              "clip-rule": "evenodd"
            })
          ])
        ], -1 /* HOISTED */))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, "#" + _toDisplayString($data.id), 1 /* TEXT */)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.players, (p, i) => {
      return (_openBlock(), _createBlock(_component_team_player, {
        class: _normalizeClass(["border-4 border-dashed", ($props.activePlayer && $props.activePlayer.id == p.id) ? 'border-red-900': 'border-transparent']),
        onClick: $event => ($options.activatePlayer($event, p)),
        key: p.id,
        player: p,
        left: p.x,
        top: p.y
      }, null, 8 /* PROPS */, ["class", "onClick", "player", "left", "top"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createCommentVNode(" Field "),
    _createElementVNode("img", {
      id: "field",
      src: "/img/field.png",
      alt: "",
      class: "mt-2 w-full grow",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('selected', null)))
    }),
    _createCommentVNode(" Watermark "),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute left-2 bottom-3 pl-2 pr-2" }, [
      _createElementVNode("img", {
        src: "/img/logo.png",
        alt: "",
        class: "h-8 grayscale opacity-25"
      })
    ], -1 /* HOISTED */))
  ], 32 /* NEED_HYDRATION */))
}